// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__31qmu","tab":"ProcedureTabs_tab__1tYku"};